<p-dialog
  *ngIf="dialogState.isOpen"
  [appendTo]="'body'"
  [(visible)]="dialogState.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  (visibleChange)="closeDialog()"
>
  <div class="details-header flex justify-content-between align-items-center mt-2 no-print">
    <div class="flex gap-2 align-items-center">
      <i class="pi pi-times secondary-button p-0 mr-2" (click)="closeDialog()"></i>
      <button class="semiround-button" (click)="moveUp()" data-clarity-unmask="true">
        <i class="pi pi-angle-up"></i>
      </button>
      <button class="semiround-button" (click)="moveDown()" data-clarity-unmask="true">
        <i class="pi pi-angle-down"></i>
      </button>
      {{ dataIndex + 1 }} z {{ dataList.length }} wyników
    </div>
    <div>Data utworzenia: {{ data.created | date: 'yyyy-MM-dd HH:mm' }}</div>
  </div>

  <ng-template pTemplate="content">
    <div id="printable-package-details" *ngIf="packageDetails">
      <div class="package-title-row flex justify-content-between align-items-center mt-5 mb-3">
        <div class="title-background-big">
          Lista {{ packageDetails.accessGeneratedCount }} użytkowników
          <span class="text-base font-normal" *ngIf="packageDetails.validDays">
            ({{ packageDetails.validDays }} dni dostępu)
          </span>
        </div>
        <div class="flex gap-2 no-print">
          <p-button
            icon="pi pi-file-pdf"
            label="Pobierz instrukcje"
            styleClass="p-button-outlined"
            [loading]="generatingInstructionsAll"
            (onClick)="downloadAllInstructions()"
            data-clarity-unmask="true"
          ></p-button>
          <p-button icon="pi pi-print" label="Wydrukuj listę" (onClick)="printList()" data-clarity-unmask="true"></p-button>
        </div>
      </div>
      <div class="mb-3" *ngIf="packageDetails.oskName">
        Przypisany OSK: <b>{{ packageDetails.oskName }}</b>
      </div>

      <div class="ticket-table-scroll">
        <table class="w-full book-access-ticket-table">
          <thead>
            <tr>
              <th>Lp.</th>
              <th>Kod</th>
              <th>Wykorzystany</th>
              <th>Nazwa użytkownika</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr class="book-access-ticket-row" *ngFor="let ticket of packageDetails.accessTickets; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ ticket.code }}</td>
              <td>
                {{ ticket.isUsed ? 'Tak' : 'Nie' }}
                <span *ngIf="ticket.isUsed && ticket.usedDate">({{ ticket.usedDate | date: 'dd.MM.yyyy' }})</span>
              </td>
              <td>{{ticket.usedByEmail}}</td>
              <td class="no-print">
                <div class="flex align-items-center gap-3">
                  <div (click)="openQrCode(ticket)" class="pi pi-eye cursor-pointer hover" [tooltipPosition]="'left'" [pTooltip]="'Podgląd kodu QR'"></div>
                  <div
                    (click)="downloadInstructionForTicket(ticket, i)"
                    class="pi cursor-pointer hover"
                    [class.pi-file-pdf]="generatingInstructionCode !== ticket.code"
                    [class.pi-spin]="generatingInstructionCode === ticket.code"
                    [class.pi-spinner]="generatingInstructionCode === ticket.code"
                    [pTooltip]="'Pobierz instrukcję dla tego kodu'"
                    [tooltipPosition]="'left'"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="label-print-only">
      <div class="label-page" *ngFor="let page of labelPages">
        <div class="label-slot" *ngFor="let ticket of page">
          <ng-container *ngIf="ticket">
            <div class="label-value label-code">{{ ticket.code }}</div>
            <qrcode
              class="label-qr"
              [qrdata]="buildSignUpUrl(ticket.code)"
              [width]="70"
              [errorCorrectionLevel]="'M'"
              [elementType]="'svg'"
              [margin]="0"
            ></qrcode>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end no-print">
      <p-button
        styleClass="link-btn"
        label="Usuń listę"
        [link]="true"
        [disabled]="isDeleteLocked"
        [pTooltip]="isDeleteLocked ? 'Nie można usunąć wydrukowanej listy lub listy z wykorzystanymi kodami' : ''"
        (click)="deleteList()"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
